import type { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './StatList.module.scss'

export interface StatListItem {
  key: ReactNode
  value: ReactNode
}

export interface StatListProps {
  items: StatListItem[]
  className?: string
}

/** Key/value rows for detail side panels. */
export function StatList({ items, className }: StatListProps) {
  return (
    <dl className={clsx(styles.statList, className)}>
      {items.map((item, i) => (
        <div key={i} className={styles.statRow}>
          <dt className={styles.statKey}>{item.key}</dt>
          <dd className={styles.statValue} style={{ margin: 0 }}>
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
